export var SET_PROGRESS_VALUE = 'SET_PROGRESS_VALUE';
export var ADD_PROGRESS_BAR = 'ADD_PROGRESS_BAR';
export var REMOVE_PROGRESS_BAR = 'REMOVE_PROGRESS_BAR';
